const ToolsService = {
  capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },

  navigateTo(path: string): void {
    window.location.href = path;
  }
};

export default ToolsService;
